enum ExternalLinkEnum {
	PORTAL = '/portal-da-privacidade/politica-privacidade',
}

export {ExternalLinkEnum};
